(() => {
  const DESKTOP = '(min-width: 769px)';
  const norm = (v) => (v || '').trim().toLowerCase().replace(/\s+/g, ' ');

  class SarattiBridalMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.cleanups = [];
      this.mq = matchMedia(DESKTOP);
      this.target = norm(this.dataset.targetLink);
      this.hoverTabs = this.dataset.openOnHover === 'true';
      this.header = document.querySelector('store-header');
      this.tabs = [...this.querySelectorAll('[data-saratti-bridal-tab]')];
      this.panels = [...this.querySelectorAll('[data-saratti-bridal-panel]')];
      this.closeButtons = [...this.querySelectorAll('[data-saratti-bridal-close]')];
      this.timer = null;
      this.findTrigger();
      this.buildMobile();
      this.bindDesktop();
      this.bindMobile();
      this.bindGlobal();
      this.observeDrawer();
      this.sync();
      this.hidden = false;
    }

    disconnectedCallback() {
      this.cleanups.forEach((fn) => fn());
      this.observer?.disconnect();
      this.mobile?.remove();
      clearTimeout(this.timer);
    }

    on(el, type, fn, options) {
      if (!el) return;
      el.addEventListener(type, fn, options);
      this.cleanups.push(() => el.removeEventListener(type, fn, options));
    }

    findTrigger() {
      const items = [...document.querySelectorAll('store-header .main-nav > li')];
      this.triggerItem = items.find((li) => {
        const a = li.querySelector(':scope > details > summary .main-nav__item--primary, :scope > a.main-nav__item--primary');
        return norm(a?.textContent) === this.target;
      });
      if (!this.triggerItem) return;
      this.triggerDetails = this.triggerItem.querySelector(':scope > details');
      this.triggerSummary = this.triggerDetails?.querySelector(':scope > summary');
      this.triggerLink = this.triggerItem.querySelector(':scope > details > summary .main-nav__item--primary, :scope > a.main-nav__item--primary');
      this.defaultPanel = this.triggerDetails?.querySelector(':scope > .main-nav__child');
      this.drawer = document.querySelector('store-header .main-menu__disclosure');
      this.mobileHost = document.querySelector('store-header .main-menu__content');
      this.triggerLink?.setAttribute('aria-haspopup', 'true');
      this.triggerItem.classList.add('has-saratti-bridal-menu');

      const click = (e) => {
        if (this.mq.matches) {
          e.preventDefault();
          e.stopPropagation();
          this.desktopOpen() ? this.closeDesktop() : this.openDesktop();
        } else {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.openMobile('landing');
        }
      };
      this.on(this.triggerSummary || this.triggerLink, 'click', click, true);
      this.on(this.triggerItem, 'pointerenter', () => this.mq.matches && this.openDesktop());
      this.on(this.triggerItem, 'pointerleave', () => this.mq.matches && this.scheduleClose());
      this.on(this.triggerLink, 'focus', () => this.mq.matches && this.openDesktop());
    }

    buildMobile() {
      if (!this.mobileHost || !this.tabs.length) return;
      const shell = document.createElement('div');
      shell.id = `SarattiBridalMobile-${this.dataset.sectionId}`;
      shell.className = 'saratti-bridal-mobile';
      shell.setAttribute('aria-hidden', 'true');
      shell.style.cssText = [
        `--saratti-bridal-bg:${getComputedStyle(this).getPropertyValue('--saratti-bridal-bg') || '#fff'}`,
        `--saratti-bridal-text:${getComputedStyle(this).getPropertyValue('--saratti-bridal-text') || '#2d334b'}`,
        `--saratti-bridal-accent:${getComputedStyle(this).getPropertyValue('--saratti-bridal-accent') || '#2d334b'}`
      ].join(';');

      const screen = (id, title, back) => {
        const section = document.createElement('section');
        section.className = 'saratti-bridal-mobile__screen';
        section.dataset.mobileScreen = id;
        section.hidden = id !== 'landing';
        const head = document.createElement('header');
        head.className = 'saratti-bridal-mobile__header';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'saratti-bridal-mobile__back';
        btn.dataset.mobileBack = back;
        btn.setAttribute('aria-label', back === 'main' ? 'Back to main menu' : `Back to ${this.dataset.targetLink}`);
        btn.innerHTML = '<span aria-hidden="true">‹</span>';
        const h = document.createElement('h2');
        h.className = 'saratti-bridal-mobile__title';
        h.textContent = title;
        head.append(btn, h, document.createElement('span'));
        section.append(head);
        return section;
      };

      const landing = screen('landing', this.dataset.targetLink, 'main');
      const landingGrid = document.createElement('div');
      landingGrid.className = 'saratti-bridal-mobile__category-grid';

      this.tabs.forEach((tab, i) => {
        const panel = this.panels[i];
        const first = panel?.querySelector('.saratti-bridal-card');
        const category = document.createElement('button');
        category.type = 'button';
        category.className = `saratti-bridal-mobile__category${i === this.tabs.length - 1 ? ' saratti-bridal-mobile__category--featured' : ''}`;
        category.dataset.mobileOpen = tab.dataset.blockId || String(i);
        const media = first?.querySelector('.saratti-bridal-card__media')?.cloneNode(true) || document.createElement('span');
        media.classList.add('saratti-bridal-mobile__category-media');
        media.querySelector('img')?.classList.add('saratti-bridal-mobile__image');
        const label = document.createElement('span');
        label.className = 'saratti-bridal-mobile__category-label';
        label.textContent = tab.textContent.trim();
        category.append(media, label);
        landingGrid.append(category);

        const detail = screen(category.dataset.mobileOpen, tab.textContent.trim(), 'landing');
        const grid = document.createElement('div');
        grid.className = 'saratti-bridal-mobile__destination-grid';
        panel?.querySelectorAll('.saratti-bridal-card').forEach((card) => {
          const clone = card.cloneNode(true);
          clone.className = 'saratti-bridal-mobile__destination';
          clone.querySelector('.saratti-bridal-card__media')?.classList.add('saratti-bridal-mobile__destination-media');
          clone.querySelector('img')?.classList.add('saratti-bridal-mobile__image');
          clone.querySelector('.saratti-bridal-card__label')?.classList.add('saratti-bridal-mobile__destination-label');
          grid.append(clone);
        });
        detail.append(grid);
        const footerLink = panel?.querySelector('.saratti-bridal-menu__footer a');
        if (footerLink) {
          const wrap = document.createElement('div');
          wrap.className = 'saratti-bridal-mobile__cta-wrap';
          const cta = footerLink.cloneNode(true);
          cta.className = 'saratti-bridal-mobile__cta';
          cta.querySelector('[aria-hidden="true"]')?.remove();
          wrap.append(cta);
          detail.append(wrap);
        }
        const support = panel?.querySelector('.saratti-bridal-menu__footer p');
        if (support) {
          const p = support.cloneNode(true);
          p.className = 'saratti-bridal-mobile__supporting';
          detail.append(p);
        }
        shell.append(detail);
      });
      landing.append(landingGrid);
      shell.prepend(landing);
      this.mobileHost.append(shell);
      this.mobile = shell;
      this.mobileScreens = [...shell.querySelectorAll('[data-mobile-screen]')];
      this.setMobileFocusable(false);
    }

    bindDesktop() {
      this.tabs.forEach((tab, i) => {
        const activate = () => this.activateTab(i);
        this.on(tab, 'click', activate);
        if (this.hoverTabs) this.on(tab, 'pointerenter', activate);
        this.on(tab, 'keydown', (e) => {
          let n;
          if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = this.tabs.length - 1;
          if (n === undefined) return;
          e.preventDefault();
          this.activateTab(n);
          this.tabs[n].focus();
        });
      });
      this.on(this, 'pointerenter', () => clearTimeout(this.timer));
      this.on(this, 'pointerleave', () => this.scheduleClose());
      this.closeButtons.forEach((b) => this.on(b, 'click', () => this.closeDesktop()));
    }

    bindMobile() {
      if (!this.mobile) return;
      this.on(this.mobile, 'click', (e) => {
        const opener = e.target.closest('[data-mobile-open]');
        if (opener) this.showMobile(opener.dataset.mobileOpen);
        const back = e.target.closest('[data-mobile-back]');
        if (!back) return;
        back.dataset.mobileBack === 'main' ? this.closeMobile() : this.showMobile('landing');
      });
    }

    bindGlobal() {
      this.on(document, 'keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.mobileOpen()) {
          const active = this.mobileScreens.find((s) => !s.hidden)?.dataset.mobileScreen;
          active !== 'landing' ? this.showMobile('landing') : this.closeMobile();
        } else if (this.desktopOpen()) {
          this.closeDesktop();
          this.triggerLink?.focus();
        }
      });
      this.on(document, 'click', (e) => {
        if (this.desktopOpen() && !this.contains(e.target) && !this.triggerItem?.contains(e.target)) this.closeDesktop();
      });
      this.on(window, 'resize', () => {
        if (this.desktopOpen()) this.positionDesktop();
        if (this.mobileOpen()) this.positionMobile();
      });
      this.on(window, 'scroll', () => {
        if (this.desktopOpen()) this.positionDesktop();
      }, { passive: true });
      const change = () => this.sync();
      if (this.mq.addEventListener) this.on(this.mq, 'change', change);
      else {
        this.mq.addListener(change);
        this.cleanups.push(() => this.mq.removeListener(change));
      }
      this.on(document, 'shopify:block:select', (e) => {
        const i = this.tabs.findIndex((t) => t.dataset.blockId === e.detail?.blockId);
        if (i < 0) return;
        if (this.mq.matches) {
          this.activateTab(i);
          this.openDesktop();
        } else this.openMobile(this.tabs[i].dataset.blockId || String(i));
      });
    }

    observeDrawer() {
      if (!this.drawer) return;
      this.observer = new MutationObserver(() => {
        if (!this.drawer.hasAttribute('open')) this.closeMobile(true);
      });
      this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
    }

    sync() {
      if (this.mq.matches) {
        this.closeMobile(true);
        this.triggerItem?.classList.add('has-saratti-bridal-menu');
        this.defaultPanel?.setAttribute('aria-hidden', 'true');
        this.triggerLink?.setAttribute('aria-controls', this.id);
      } else {
        this.closeDesktop(true);
        this.triggerItem?.classList.remove('has-saratti-bridal-menu');
        this.defaultPanel?.removeAttribute('aria-hidden');
        this.triggerLink?.setAttribute('aria-controls', this.mobile?.id || this.id);
      }
    }

    activateTab(i) {
      this.tabs.forEach((t, n) => {
        const active = n === i;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active);
        t.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((p, n) => {
        p.classList.toggle('is-active', n === i);
        p.hidden = n !== i;
      });
    }

    positionDesktop() {
      const bottom = this.header?.getBoundingClientRect().bottom || 0;
      this.style.setProperty('--saratti-bridal-top', `${Math.max(0, Math.round(bottom))}px`);
    }

    openDesktop() {
      if (!this.mq.matches || !this.triggerItem) return;
      clearTimeout(this.timer);
      const nativeMenu = this.header?.querySelector('main-menu');
      const nativeDisclosure = nativeMenu?.querySelector('.main-nav > li > details.is-open');
      if (nativeDisclosure) nativeMenu.close(nativeDisclosure, false);
      if (nativeMenu?.overlayOpen) nativeMenu.toggleOverlay(false);
      this.positionDesktop();
      this.classList.add('is-open');
      this.triggerLink?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('saratti-bridal-menu-open');
    }

    closeDesktop(immediate = false) {
      clearTimeout(this.timer);
      this.classList.remove('is-open');
      if (this.mq?.matches) this.triggerLink?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('saratti-bridal-menu-open');
      if (immediate) this.style.removeProperty('--saratti-bridal-top');
    }

    scheduleClose() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.closeDesktop(), 190);
    }

    positionMobile() {
      if (!this.mobileHost || !this.mobile) return;
      const r = this.mobileHost.getBoundingClientRect();
      this.mobile.style.setProperty('--saratti-mobile-top', `${Math.round(r.top)}px`);
      this.mobile.style.setProperty('--saratti-mobile-left', `${Math.round(r.left)}px`);
      this.mobile.style.setProperty('--saratti-mobile-width', `${Math.round(r.width)}px`);
      this.mobile.style.setProperty('--saratti-mobile-height', `${Math.round(r.height)}px`);
    }

    showMobile(id) {
      let active;
      this.mobileScreens?.forEach((s) => {
        const match = s.dataset.mobileScreen === id;
        s.hidden = !match;
        if (match) active = s;
      });
      if (!active) return this.showMobile('landing');
      this.mobile.scrollTop = 0;
      requestAnimationFrame(() => active.querySelector('[data-mobile-back]')?.focus({ preventScroll: true }));
    }

    openMobile(id = 'landing') {
      if (this.mq.matches || !this.mobile) return;
      this.positionMobile();
      this.showMobile(id);
      this.setMobileFocusable(true);
      this.mobile.classList.add('is-open');
      this.mobile.setAttribute('aria-hidden', 'false');
      this.triggerLink?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('saratti-bridal-mobile-open');
      requestAnimationFrame(() => this.resetTrap(this.mobileScreens.find((s) => !s.hidden)?.querySelector('[data-mobile-back]')));
    }

    closeMobile(immediate = false) {
      if (!this.mobile) return;
      this.mobile.classList.remove('is-open');
      this.mobile.setAttribute('aria-hidden', 'true');
      this.triggerLink?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('saratti-bridal-mobile-open');
      this.setMobileFocusable(false);
      if (!immediate && !this.mq.matches) {
        this.resetTrap(this.triggerLink);
        this.triggerLink?.focus({ preventScroll: true });
      }
    }

    setMobileFocusable(on) {
      this.mobile?.querySelectorAll('a,button').forEach((el) => {
        if (on) el.removeAttribute('tabindex');
        else el.tabIndex = -1;
      });
    }

    resetTrap(focus) {
      if (!this.drawer?.hasAttribute('open')) return;
      try {
        if (typeof removeTrapFocus === 'function') removeTrapFocus();
        if (typeof trapFocus === 'function') trapFocus(this.drawer, focus || this.drawer);
      } catch (_) {}
    }

    desktopOpen() { return this.classList.contains('is-open'); }
    mobileOpen() { return this.mobile?.classList.contains('is-open'); }
  }

  if (!customElements.get('saratti-bridal-menu')) customElements.define('saratti-bridal-menu', SarattiBridalMenu);
})();